
import { useEffect, useState } from "react";

import { URL_BACKEND } from "../../api/url";

const useBuscarAspirantes = () => {


    // variables
    const [data, setData] = useState()
    const [resultados, setResultados] = useState([])
    const [loading, setLoading] = useState( true )
    const [ciclosExamen, setCiclosExamen] = useState([])
    const [ciclo, setCiclo] = useState('2022-2023')

    // funciones
    const traerAspirantes = () => {

        let datos = new FormData()
        datos.append('funcion', 'traerAspirantesBusqueda');
        datos.append('ciclo', ciclo);

        fetch( URL_BACKEND, {
            method: 'post',
            body: datos
        })
        .then( res => res.json() )
        .then( d => {
            setData( d )
            setResultados( d )
        })
        .finally(() => setLoading( false ))
    }


    const traerCiclosExamen = () => {

        let datos = new FormData()
        datos.append('funcion', 'traerCiclosExamen');

        fetch( URL_BACKEND, {
            method: 'post',
            body: datos
        })
        .then( res => res.json() )
        .then( setCiclosExamen )
    }


    const filtrar = ( e ) => {

        let cosaABuscar = e.target.value

        if (cosaABuscar) {
            // aquí haremos una búsqueda porque el usuario escribió algo
            var resultadosNuevos = data.filter( function( elemento ){

                let busqueda = new RegExp( cosaABuscar, 'gi' )
                if ( busqueda.test( elemento.nombre ) || busqueda.test( elemento.curp ) || busqueda.test( elemento.prematricula ) ) {
                    return true
                } else {
                    return false
                }

            })
            setResultados( resultadosNuevos )

        } else {
            // aquí no haremos la búsqueda, pero devolvemos todos los elementos
            setResultados( data )
        }
    }

    // useEffects
    useEffect(() => {
        traerAspirantes()
        traerCiclosExamen()
        // eslint-disable-next-line
    }, [])


    useEffect(() => {
        traerAspirantes()
        // eslint-disable-next-line
    }, [ ciclo ])


    // tabla
    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'nombre',
        },
        {
            title: 'Prematricula',
            dataIndex: 'prematricula',
        },
        {
            title: 'Curp',
            dataIndex: 'curp',
        },
    ];


    return {
        resultados, columns, loading, filtrar, ciclosExamen, ciclo, setCiclo
    }
}

export default useBuscarAspirantes
